/*
    Customize form functionality on a successful form submission.
*/
var form = document.querySelector('.frm_ajax_submit');

if (form) {
    // Add an event listener for the form's submit event
    form.addEventListener('submit', function(event) {
        // Prevent the default form submission
        event.preventDefault();

        // Function to handle form submission
        function handleFormSubmission() {
            // Check for elements with class 'frm_error'
            var errorElements = document.querySelectorAll('.frm_error');
            if (errorElements.length > 0) {
                // Do nothing if there are errors
                return; // Stop checking if there are errors
            }

            // Check for the element with class 'frm_message'
            var successElement = document.querySelector('.frm_message');
            if (successElement) {
                // Remove specific DOM elements on success
                removeElements(['.frm-headline-area', '.frm-content-area', '.frm-footer-area']);
                return; // Stop checking once success is found
            }

            // Continue checking for success message
            setTimeout(handleFormSubmission, 100); // Check again after 100ms
        }

        // Start handling form submission
        handleFormSubmission();
    });
}

// Function to remove DOM elements
function removeElements(selectorArray) {
    selectorArray.forEach(function(selector) {
        var elements = document.querySelectorAll(selector);
        elements.forEach(function(element) {
            element.remove();
        });
    });
}
